import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';

import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MdPaginator, MdSort } from '@angular/material';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { IesHttpClient } from '../../Common/ies-http-client.service';
import { Enum } from '../../utility/enum.enum';
import { AppUrl } from './../../Common/appUrl';
import { TableDataSource } from './../../Common/md-table';
import { AppGlobals } from './../../Common/Services/app.global';
import { SharedService } from './../../Common/Services/shared.service';
import { Utility } from './../../Common/Services/utility';
import { userRole_globalAdmin } from './../../Common/appConstant';
import { FeatureFlagService, ToggleName } from 'app/Common/Services/feature-flag.service';

@Component({
  selector: 'app-adm-manage-global-admin',
  templateUrl: './adm-manage-global-admin.component.html',
  styleUrls: ['./adm-manage-global-admin.component.css'],
  providers: [FeatureFlagService]
})


export class AdmManageGlobalAdminComponent implements OnInit, OnDestroy {


  @ViewChild(MdPaginator) paginator: MdPaginator;
  @ViewChild(MdSort) sort: MdSort;

  // used in html to pass url/searchParams to update pagination
  appUrl = AppUrl;
  httpClient: IesHttpClient; // used to make object of md-table
  searchForm: FormGroup;
  initialPageSize: number = 100; // page Size which we need from server
  nameOptions: IElement[];
  dataSource: TableDataSource | null;
  dataSubject: BehaviorSubject<IElement[]> = new BehaviorSubject<IElement[]>([]); // store all grid data

  adminDetailPaginationInfo: any = { totalRecords: 0 }; // Set initial value of Totalrecords property
  displayedColumns = ['firstName', 'lastName', 'email', 'contactNo', 'rhId', 'status', 'Action'];

  constructor(private featureFlags: FeatureFlagService, private _route: Router, private _sharedService: SharedService, public _utility: Utility, httpClient: IesHttpClient, public _appGlobal: AppGlobals) {
    this.httpClient = httpClient;
    this.searchForm = new FormGroup(
      {
        searchNameControl: new FormControl()
      }
    )
  }

  private redirect(): void {
    window.location.assign("/ies/internal/manage-global-administrators");
  }

  ngOnInit() {
    this.featureFlags.on("ready", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_MANAGE_GLOBAL_ADMINISTRATORS_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.on("update", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_MANAGE_GLOBAL_ADMINISTRATORS_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.start();
    this.nameOptions = [];
    this.dataSource = new TableDataSource(this.dataSubject, this.paginator, this.sort, this.httpClient);
    this._utility.addLoaderCount();
    this._sharedService.getUsers("?userRole=" + userRole_globalAdmin)
      .subscribe(
      response => {
        this._utility.onSuccessCallback(response, null, () => {
          this.dataSubject.next(response.response.results);
          this.adminDetailPaginationInfo = response.response.paginationInfo; // update paginaton info
        });

      }, error => this._utility.onErrorCallback(error));

    this.searchForm.controls.searchNameControl.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.nameChanges(value);
      });

  }

  ngOnDestroy(): void {
      this.featureFlags.stop();
  }


  /* This function called When we type something on search "Enter First Name or Last Name" field
   * If there are three later typed then hit request after half seconds of that to get suggestion
   * Set all returned data into nameOptions array
   */
  nameChanges(searchInput: string): void {
    let distinctName = [];
    if (searchInput && searchInput.length > 2) {
      this._sharedService.getUsers("?userRole="+userRole_globalAdmin+"&searchText=" + searchInput)
        .subscribe(
        response => {
          this._utility.onSuccessCallback(response, null, () => {
            let adminList = response.response.results;
            if (adminList.length > 0) {
              distinctName = this._utility.checkDuplicateRecord(adminList);
            }
            this.nameOptions = distinctName;
          });
        },
        error => {
          this._utility.onErrorCallback(error);
        });
    }
  }


  /* When we click on search button then call this function
     If we select a value from autoComplete box then just set that record into grid
     Else hit a request with search text and set data in grid
    */
  onSearchBtnClick(): void {
    let params = "?userRole=" + userRole_globalAdmin + "&";
    let controls = this.searchForm.controls;
    if (controls.searchNameControl.value)
      params += `searchText=${controls.searchNameControl.value}&`;
    this._utility.addLoaderCount();
    this._sharedService.getUsers(params.substring(0, params.length - 1))
      .subscribe(response => {
        this._utility.onSuccessCallback(response, null, () => {
          //initialize index of grid pagination after every search
          this.paginator.pageIndex = 0;
          this.dataSource.curPage = 2;
          this.dataSubject.next(response.response.results);
          this.adminDetailPaginationInfo = response.response.paginationInfo; // update paginaton info
        });
      }, error => this._utility.onErrorCallback(error));

  }

 /**
  * Used active & retired Icon based on it's value
  * @param value = 1 for active & 3 for retire
  */
  getStatusCls(value) {
    try {
      if (value == Enum.StatusActive) return 'activeStatusCls';
      if (value == Enum.StatusRetire) return 'retireStatusCls';
    }
    catch (Exception) { }
  }
}

// Created Interface for drop down with input field
export interface IElement {
  id: number,
  FirstName: string,
  LastName: string,
  showStr: string
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-global-admin/adm-manage-global-admin.component.ts